import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Landing } from "./pages/Landing";
import { DentalProposal } from "./pages/DentalProposal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/platinumdentalproposal2026" element={<DentalProposal />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
